import React, { Component } from 'react';
import api from '../../ApiService';
import FormLabel from '@material-ui/core/FormLabel';
import { FileUpload } from 'primereact/fileupload';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

export default class ProviderMappings extends Component {
    constructor() {
        super();

        this.state = {
            selectedFile: "",
            load: false,
            importFile: { fileBytes: "" },
            importProcessed: false,
            loadingMappings: false,
            loadingSummary: false,
            mismappingsTable: [],
            mismappingCount: "",
            mappingViewTabs: [],
            selectedTab: "Provider Mapping"
        };
    }

    componentDidMount = async () => {
        this.setState({ loadingSummary: true });
        var result = await api.getProviderMismappingCount();

        this.setState({ mismappingCount: result.mismappingCount, loadingSummary: false });
    }

    //---------------------
    // File upload handlers
    //---------------------
    onBeforeSend = (e) => {
        e.xhr.setRequestHeader('authorization', `Bearer ${localStorage.getItem('token')}`);
        toast.warn("Uploading file...", { autoClose: false, position: 'bottom-right' });
    }

    onUpload = async (e) => {
        toast.dismiss();
        toast.success('Upload successful.');

        this.setState({ loadingMappings: true, loadingSummary: true, importProcessed: true });

        // TODO GET remaining mismappings
        let mismappingsTable = await api.getProviderMismappings();
        let result = await api.getProviderMismappingCount();

        this.setState({ loadingMappings: false, mismappingsTable, mismappingCount: result.mismappingCount, loadingSummary: false });
    }

    onError = (e) => {
        toast.error('Trouble uploading file.', { autoClose: 5000 });
    }


    //renderTabs = () => {
    //    let tabsToRender = [];
    //    tabsToRender.push(<Tab label="Provider Mapping" key="ProviderMapping" value="Provider Mapping" />);
    //    tabsToRender.push(<Tab label="Vetdata Revenue Mapping" key="VetdataRevenueMapping" value="Vetdata Revenue Mapping" />);

    //    let selectedTab = this.state.selectedTab;

    //    return (
    //        <Tabs value={selectedTab} onChange={(event, value) => this.setState({ selectedTab: value })}>
    //            {tabsToRender.map((value) => value)}
    //        </Tabs>
    //    );
    //}

    renderFileDropzone() {

        let url = `api/providermappings/providermappings`;
        let label = 'Upload Provider Mappings';
        if (this.state.isDirty === true) label += ' (disabled due to pending edits)';
        return (
            <div>
                <FormLabel component='span'>{label}</FormLabel>
                <FileUpload name='xlsxFile' url={url} auto accept=".xlsx,.XLSX" chooseLabel="CHOOSE" style={{ backgroundColor: 'gray' }}
                    onBeforeSend={this.onBeforeSend} onUpload={this.onUpload} onError={this.onError}
                />
            </div>
        );
    }

    renderSummaryTable() {
        return (
            <Table xs={10}>
                <TableHead>
                    <TableRow className="validation-table-highlight">
                        <TableCell component="th" style={{ textAlign: 'left', fontWeight: '500', fontSize: 'unset', color: 'black' }}># of Mismappings</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell component="th" scope="row" style={{ fontWeight: '500', fontSize: 'unset' }}>{this.state.mismappingCount}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        );
    }

    renderDetailsTable() {
        // Note!: If you add resizeablecolumns then the dropdown expands only in the active cell - effectively hiding it

        return (
            <div>
                <DataTable value={this.state.mismappingsTable.mismappingsTable}>
                    <Column field="sysSource" header="SysSource" sortable="true" style={{ width: '10%' }} />
                    <Column field="workDayLocation" header="WorkdayDay Location" sortable="true" style={{ width: '10%' }} />
                    <Column field="iVetHospitalId" header="Ivet Hospital Id" sortable="true" style={{ width: '10%' }} />
                    <Column field="iVetProviderId" header="Ivet Provider Id" sortable="true" style={{ width: '10%' }} />
                    <Column field="iVetProviderName" header="Ivet Provider Name" sortable="true" style={{ width: '10%' }} />
                    <Column field="workdayProviderId" header="Workday Provider Id" sortable="true" style={{ width: '15%' }} />
                    <Column field="workdayProviderName" header="Workday Provider Name" sortable="true" style={{ width: '15%', textAlign: 'center' }} />
                    <Column field="costCenter" header="Cost Center" sortable="true" style={{ width: '8%', textAlign: 'center' }} />
                    <Column field="costCenterEffectiveDate" header="Cost Center Effective Date" sortable="true" style={{ width: '12%', textAlign: 'center' }}  />
                </DataTable>
            </div>
        );
    }

    render() {
        let summaryTable = this.state.loadingSummary ? <em>Loading...</em> : this.renderSummaryTable();
        let fileDropzone = this.renderFileDropzone();
        let mappingDetails = this.state.loadingMappings ? <em>Loading...</em> : this.renderDetailsTable();

        return (
            <div>
                <br />
                {summaryTable}
                <hr />
                {fileDropzone}
                <hr />
                {this.state.importProcessed &&
                    mappingDetails
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Mappings/ProviderMappings.js